import axios from "axios"
import { Toast } from "vant";
import qs from "qs"
import Rsa from "@/utils/rsa.js";
import Aes from "@/utils/aes.js";
import fc from "@/utils/funct.js";
axios.defaults.baseURL = process.env.VUE_APP_BASE_API;
// axios.defaults.baseURL = "http://113.204.34.182:62112"//测试邀请注册
// axios.defaults.baseURL = "https://www.mcytgj.cn/mcjyt"//正式麻城公交
// axios.defaults.timeout = 10000; //超时时间
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'; //请求头

// 'MAASP-TOKEN': 'c7c72e9d6f384ae39b594271c60f3c5a',
const getEncryptData = function (params) {
    // 生成一个随机16位串
    let randStr = fc.createRandStr();
    // 设置请求头headers参数，进行rsa加密
    let secret = Rsa.encrypt(randStr, process.env.VUE_APP_PUBLIC_KEY);
    // 包裹加密对象，进行aes加密
    params = typeof params == 'undefined' ? '' : params;
    let str = typeof params == 'string' ? params : JSON.stringify(params);
    let aesStr = Aes.encrypt(str, randStr);
    return {
        params: aesStr,
        secret: secret
    };
};
// 请求拦截器
axios.interceptors.request.use((config) => {
    config.headers['appid'] = 'mc'
    let token = sessionStorage.getItem('token')
    if (token) {
        config.headers['MAASP-TOKEN'] = token;
    }
    // else{
    //     window.location.reload()
    // }
    // token && (config.headers['MAASP-TOKEN'] = token);
    let data = {};
    
    if (config.method === 'get') {
        config.params = typeof config.params == 'undefined' ? '' : config.params; 
        let paramStr = fc.tansParams(config.params);
        data = getEncryptData(paramStr);
        // console.log('query',paramStr,data);
        let url = config.url + '?p=' + data.params;
        // url = url.slice(0, -1);
        config.params = {};
        config.url = url;
      } else {
        data = getEncryptData(config.data);
        config.data = data.params
        
    }
    config.headers['secret'] = data.secret
    return config;
})
// 响应拦截器
axios.interceptors.response.use((response) => {
    let secret = response.headers['secret'];
    if (typeof secret == 'string') {
        // 进行rsa解密
        let randStr = Rsa.decrypt(secret,
            process.env.VUE_APP_PUBLIC_KEY);
        // 进行aes解密
        let data = Aes.decrypt(response.data.data, randStr);
        response.data.data = fc.checkJson(data) == true ? JSON.parse(data) : data;
    }
    // console.log('response',response)
    return response;
}, error => {
    console.log('repose', error)
    Toast.fail('网络异常，稍后再试');
    return Promise.error(error);
})

export default {
    get(url, data = {}) {
        return new Promise((resolve, reject) => {
            axios.get(url, {
                    params: data
                })
                .then((response) => {
                    resolve(response.data)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
    post(url, data = {}) {
        return new Promise((resolve, reject) => {
            axios.post(url, data)
                .then((response) => {
                    resolve(response.data)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    }
}

// // 请求拦截器
// axios.interceptors.request.use(
//     config => {
//         const token = localStorage.getItem('token_driver')
//         token  &&  (config.headers.common["Authorization"]  =  token);
//         return config;
//     },
//     error => {
//         return Promise.error(error);
//     }
// )

// // 响应拦截器
// axios.interceptors.response.use(res => {
//     if (res.code == 200) {
//         return Promise.resolve(res);
//     } else {
//         return Promise.resolve(res);

//     }
// }, err => {
//     console.log(err);
// })